module.exports = __webpack_public_path__ + "img/descroption.1a34c929.svg";